/**
 * CAP-40007 TCL-22 - Role-Based Access Control (RBAC) for the TCL Back Office.
 * Route guard enforcing area-level access. Each protected route declares its area via route data
 * ({ area: TclArea.XXX }); the guard consults the centralized AuthorizationService and redirects
 * users who try to reach a hidden page directly via URL. Never relies on the hidden UI alone.
 */
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthorizationService } from './authorization.service';
import { TclArea } from './roles.constants';

@Injectable({
  providedIn: 'root'
})
export class RoleGuardService implements CanActivate {

  constructor(private authz: AuthorizationService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // CAP-40007 TCL-22 - The required area is declared on the route data.
    const area: TclArea = route.data ? route.data['area'] : undefined;

    // CAP-40007 TCL-22 - Routes without an area requirement are always allowed.
    if (!area) {
      return true;
    }

    if (this.authz.canAccessArea(area)) {
      return true;
    }

    // CAP-40007 TCL-22 - Access denied: redirect to the first area the user IS allowed to see.
   
    const fallback = this.firstAllowedRoute();
    this.router.navigate([fallback]);
    return false;
  }

  /**
   * CAP-40007 TCL-22 - Resolve a safe landing route based on the current role's allowed areas.
   */
  private firstAllowedRoute(): string {
    if (this.authz.canAccessArea(TclArea.SAISIE)) {
      return '/tcl/saisie';
    }
    if (this.authz.canAccessArea(TclArea.EXTRACTION)) {
      return '/tcl/extraction';
    }
    if (this.authz.canAccessArea(TclArea.ADMIN)) {
      return '/tcl/administration';
    }
    // CAP-40007 TCL-22 - No area available: land on the shell.
    return '/tcl';
  }
}
